import {
    IMovimentacaoPeriodoMonthOption,
    IMovimentacaoPeriodoStatusOption
} from '../models/movimentacoes-periodos-ui.model';

export const MOVIMENTACAO_PERIODO_STATUS_LABELS: Record<number, string> = {
    1: 'Em período de lançamentos',
    2: 'Encerrado'
};

export const MOVIMENTACAO_PERIODO_STATUS_CLASSNAMES: Record<number, string> = {
    1: 'label-success',
    2: 'label-default'
};

export const MOVIMENTACAO_PERIOD_MONTH_OPTIONS: IMovimentacaoPeriodoMonthOption[] = [
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' }
];

export const MOVIMENTACAO_PERIOD_STATUS_OPTIONS: IMovimentacaoPeriodoStatusOption[] = [
    { value: 1, label: 'Em período de lançamentos' },
    { value: 2, label: 'Encerrado' }
];
